import "./index.css";

const OurTeam = () => {
  return (
    <div className="our-team-container">
      <div className="our-team-cards-container">
        <div className="our-team-card-container">
          <img src="/Images/ourTeam1.png" className="our-team-image" />

          {/* <img src="/Images/Rectangle 296.png" className="our-team-image" /> */}
          <div className="our-team-text-container">
            <h4 className="our-team-text-heading">
              Sreenivasa Prasad Sarvaraju
            </h4>
            <p className="our-team-text-description">
              Founder & President <br/>
              Master's Degree In Financial Management (MFM)
              Worked in S&P Capital IQ
            </p>
          </div>
        </div>

        <div className="our-team-card-container">
          <img src="/Images/Rectangle 296.png" className="our-team-image" />
          <div className="our-team-text-container">
            <h4 className="our-team-text-heading">Dr T Sundara Raj Perumall</h4>
            <p className="our-team-text-description">
              Vice President MD Ayurveda, MSc Psychology Chief Physician and
              Director of Arogyadhatri Ayurveda Chikitsalayam
            </p>
          </div>
        </div>
        <div className="our-team-card-container">
          <img src="/Images/Rectangle 296(1).png" className="our-team-image" />
          <div className="our-team-text-container">
            <h4 className="our-team-text-heading">Giridhar Kolanupaka</h4>
            <p className="our-team-text-description">
              Secretary Technical Lead, TCS, Hyderabad MS (Mechanical Eng.),
              Tennessee Technological University, USA
            </p>
          </div>
        </div>
        <div className="our-team-card-container">
          <img src="/Images/Rectangle 296(2).png" className="our-team-image" />
          <div className="our-team-text-container">
            <h4 className="our-team-text-heading">Dr. Hari Kumar Voruganti</h4>
            <p className="our-team-text-description">
              Joint Secretary <br/>
              Ph.D. from IIT Kanpur <br/>
              Associate Professor @ NIT Warangal
            </p>
          </div>
        </div>
        <div className="our-team-card-container">
          <img src="/Images/Rectangle 296(3).png" className="our-team-image" />
          <div className="our-team-text-container">
            <h4 className="our-team-text-heading">Naresh Kumar Burjukadi</h4>
            <p className="our-team-text-description">
              Treasurer <br/>
              Master of Commerce <br/>
              Working @ Indian Immunological Ltd
            </p>
          </div>
        </div>
        <div className="our-team-card-container">
          <img src="/Images/Rectangle 296(4).png" className="our-team-image" />
          <div className="our-team-text-container">
            <h4 className="our-team-text-heading">Haritha Vemulapalli</h4>
            <p className="our-team-text-description">
              Executive Member <br/>
              Master of Business Administration <br/>
              Senior Research Associate @ S&P Capital IQ
            </p>
          </div>
        </div>
        <div className="our-team-card-container">
          <img src="/Images/Rectangle 296(5).png" className="our-team-image" />
          <div className="our-team-text-container">
            <h4 className="our-team-text-heading">Sarath Chandra Vakati</h4>
            <p className="our-team-text-description">
              Executive Member <br/>
              M.Com with MFM <br/>
              Data Researcher @ S & P Global
            </p>
          </div>
        </div>
        <div className="our-team-card-container">
          <img src="/Images/Rectangle 296(6).png" className="our-team-image" />
          <div className="our-team-text-container">
            <h4 className="our-team-text-heading">Mahesh Desu</h4>
            <p className="our-team-text-description">
              Executive Member <br/>
              Master of Business Administration <br/>
              Operational Head @ Ganaay Millets Pvt Ltd
            </p>
          </div>
        </div>
        <div className="our-team-card-container">
          <img src="/Images/Rectangle 296(7).png" className="our-team-image" />
          <div className="our-team-text-container">
            <h4 className="our-team-text-heading">Dhanesh Kumar Khakkar</h4>
            <p className="our-team-text-description">
              Project Leader - 'Vikas Primary' <br/>
              Master of Business Administration <br/>
              Data Researcher @ S & P Global
            </p>
          </div>
        </div>
        <div className="our-team-card-container">
          <img src="/Images/Rectangle 296(8).png" className="our-team-image" />
          <div className="our-team-text-container">
            <h4 className="our-team-text-heading">
              Srinivasa Chakravarthi Borra
            </h4>
            <p className="our-team-text-description">
              Project Leader - 'Vikas- High School' <br/>
              Master of Computer Applications <br/>
              Software Engineer @ Cognizant Technologies
            </p>
          </div>
        </div>
        <div className="our-team-card-container">
          <img src="/Images/Rectangle 296(9).png" className="our-team-image" />
          <div className="our-team-text-container">
            <h4 className="our-team-text-heading">Siva Sankar Kantheti</h4>
            <p className="our-team-text-description">
              Core Team Member- 'CHDHC' <br/>
              Master's in Education <br/>
              Working for Viridus Social Impact Solutions
            </p>
          </div>
        </div>
        <div className="our-team-card-container">
          <img src="/Images/Rectangle 296(10).png" className="our-team-image" />
          <div className="our-team-text-container">
            <h4 className="our-team-text-heading">Parameswarachari Sharabu</h4>
            <p className="our-team-text-description">
              Project Leader - Annam Parabhramam <br/>
              Master of Business Administration <br/>
              Working as a Research Associate in S & P Global
            </p>
          </div>
        </div>
        <div className="our-team-card-container">
          <img src="/Images/Rectangle 296(11).png" className="our-team-image" />
          <div className="our-team-text-container">
            <h4 className="our-team-text-heading">Suman Yelati</h4>
            <p className="our-team-text-description">
              Core Team Member- 'CHDHC' <br/>
              B.Tech from IIIT- Hyderabad Software Architect, Bosch, USA
            </p>
          </div>
        </div>
        <div className="our-team-card-container">
          <img src="/Images/Rectangle 296(12).png" className="our-team-image" />
          <div className="our-team-text-container">
            <h4 className="our-team-text-heading">Mani Kumar Kalavala</h4>
            <p className="our-team-text-description">
              Project Leader - Share & Care <br/>
              Master of Technology Working in TATA Consultancy Services
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurTeam;
